import { render } from "./BoxShadowLayerDetail.vue?vue&type=template&id=9db95366&scoped=true&ts=true"
import script from "./BoxShadowLayerDetail.vue?vue&type=script&lang=ts"
export * from "./BoxShadowLayerDetail.vue?vue&type=script&lang=ts"

import "./BoxShadowLayerDetail.vue?vue&type=style&index=0&id=9db95366&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9db95366"]])

export default __exports__